<template>
	<div class="name-input">
		<my-input
		 :tipText="nameTip"
		 :text="name"
		 :isError="isError"
		 :maxLength="maxLength"
		 @tipClick="nameClick"
		 @blurEvent="checkName"
		></my-input>
	</div>
</template>
<script>
import * as types from "../../../store/mutation-types";
import config from "../../../util/config";
import myInput from "../../common/myInput";
import { mapGetters } from "vuex";

export default {
	components: {
		myInput
	},
	data() {
		return {
			isError: false,
			nameTip: "输入姓名",
			name: "",
			maxLength: 4,
			state: false // 填写状态
		};
	},
	computed: {
		...mapGetters(["truename", "pagetypeLog"])
	},
	watch: {
		truename(val) {
			this.name = this.truename;
		}
	},
	created() {
		this.name = this.truename;
	},
	methods: {
		nameClick(value) {
			// 第一次点击
			if (value === "") {
				this.isError = false;
				this.nameTip = "真实姓名请填写2-4个汉字";
			}
			window.clickLog &&
				window.clickLog("from=jl_nameclk" + this.pagetypeLog);
		},
		checkName(value) {
			this.name = value;
			if (value === "") {
				this.isError = true;
				this.nameTip = "输入姓名";
				this.state = false;
				window.clickLog &&
					window.clickLog("from=jl_namemiss" + this.pagetypeLog);
			} else if (!config.nameReg.test(value)) {
				this.isError = true;
				this.nameTip = "只能填写2-4个汉字";
				this.state = false;
				window.clickLog &&
					window.clickLog("from=jl_namemiss" + this.pagetypeLog);
			} else {
				this.isError = false;
				this.nameTip = "真实姓名";
				this.state = true;
			}
			this.$store.commit(types.CHECK_BASICINFO, {
				key: "truename",
				value: value,
				state: this.state
			});
		},
		// 点击保存检查为空
		checkNull() {
			this.checkName("");
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
</style>



// WEBPACK FOOTER //
// index.vue?0d0426c4